module.exports = __webpack_public_path__ + "res/MaterialIcons-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/MaterialIcons-Regular.eot
// module id = 91
// module chunks = 1